import { createContext } from 'react';
import { AuthValue, authValueDefault } from '../auth-value';

const AuthContext = createContext<AuthValue>(authValueDefault);

export { AuthContext };
